"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WixStyleParamType;
(function (WixStyleParamType) {
    WixStyleParamType["NUMBER"] = "number";
    WixStyleParamType["BOOLEAN"] = "boolean";
    WixStyleParamType["FONT"] = "font";
    WixStyleParamType["COLOR"] = "color";
    WixStyleParamType["STRING"] = "string";
})(WixStyleParamType = exports.WixStyleParamType || (exports.WixStyleParamType = {}));
var EditorMode;
(function (EditorMode) {
    EditorMode["Desktop"] = "desktop";
    EditorMode["Mobile"] = "mobile";
})(EditorMode = exports.EditorMode || (exports.EditorMode = {}));
var WixStyleSDKCollectionType;
(function (WixStyleSDKCollectionType) {
    WixStyleSDKCollectionType["NUMBERS"] = "numbers";
    WixStyleSDKCollectionType["BOOLEANS"] = "booleans";
    WixStyleSDKCollectionType["FONTS"] = "fonts";
    WixStyleSDKCollectionType["COLORS"] = "colors";
})(WixStyleSDKCollectionType = exports.WixStyleSDKCollectionType || (exports.WixStyleSDKCollectionType = {}));
//# sourceMappingURL=enums.js.map